import { type SafeHtml } from 'kerfjs';

import { BarChart } from '../../components/bar-chart.js';
import type { OrgSavingsT } from '../../data/api.js';
import { formatCurrencyText } from '../../lib/currency-format.js';
import { trailingSavingsMonths } from '../../lib/savings-months.js';

export function SavingsByMonthChart({ savings }: { savings: OrgSavingsT }): SafeHtml {
  const monthLabel = (month: string): string => {
    const [year, number] = month.split('-');
    return new Date(Number(year), Number(number) - 1, 1).toLocaleDateString(undefined, { month: 'short' });
  };
  return (
    <div class="savings-by-month-chart">
      <BarChart
        label="Savings by Month"
        bars={trailingSavingsMonths(savings.byMonth).map((month) => ({
          key: month.month,
          value: month.savings,
          label: monthLabel(month.month),
          title: `${month.month}: ${formatCurrencyText(month.savings, savings.base)}`,
        }))}
      />
    </div>
  );
}
